import React from "react";

// Slow editorial marquee. Duplicated track for seamless loop (CSS animation).
export default function Marquee({
  items,
  className = "",
  separator = "✦",
}) {
  const track = [...items, ...items];
  return (
    <div
      className={`relative w-full overflow-hidden select-none ${className}`}
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {track.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-[#0B302F]/85 text-4xl sm:text-6xl italic px-6">
              {t}
            </span>
            <span className="text-[#D5B876] text-2xl sm:text-3xl px-2">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
